import { Link } from "react-router-dom";
import styled from "styled-components";

export const Container = styled(Link) `

    padding: 10px;
    text-decoration: none;
    color: #ccc;
    border-radius: 5px;
    width: 100%;
    transition: all .3s ease;

    &:hover, &:focus {
        background: ${props => props.background_color_hover ? `${props.background_color_hover}99` : "#303030"};
    }

    .div-image {
        position: relative;
        border-radius: 5px;
        overflow: hidden;
    }

    .div-image img {
        width: 100%;
        min-width: 100%;
        aspect-ratio: 16/9;
        background: #404040;
    }

    .div-image .new-release-banner {
        position: absolute;
        top: 0;
        left: 50%;
        transform: translateX(-50%);
        width: max-content;
        background: rgb(255, 0, 0);
        color: #fff;
        font-weight: 600;
        font-size: .75em;
        border-radius: 0 0 5px 5px;
        padding: 4px 10px;
        text-align: center;
        z-index: 10;
    }

    h2 {
        margin-top: 5px;
        font-size: 1rem;
        font-weight: 700;

        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        display: -webkit-box;
        overflow: hidden;
        text-overflow: ellipsis;
    }

    @media (max-width: 600px) {
        
        padding: 5px;
        
        .div-image span {
            padding: 3px 0;
            font-size: .6rem;
        }

        h2 {
            margin-top: 5px;
            font-size: .7rem;
            -webkit-line-clamp: 2;
        }

        .div-image .new-release-banner {
            font-size: .5rem;
            border-radius: 0 0 3px 3px;
            padding: 2px 5px;
        }

    }
`